import { Product } from '@/manager/product/models/product.model';
import Bill from '@/manager/billing/models/bill.model';

export interface BillLineProduct {
    product?: Product;
    productName?: string;
    productPrice?: number;
    productAmount?: number;
    productTax?: number;
}
export interface BillLineTotalPricing {
    totalPrice?: number;
    totalPriceTax?: number;
    totalPriceWithoutTax?: number;
}

export default class BillLine implements BillLineProduct, BillLineTotalPricing {
    public id?: string;
    public product?: Product;
    public productName?: string;
    public productPrice?: number;
    public productPriceName?: any;
    public productAmount?: number;
    public productTax?: number;
    public totalPrice?: number;
    public totalPriceTax?: number;
    public totalPriceWithoutTax?: number;

    constructor() {
        this.product = new Product();
        this.productAmount = 0;
        this.productPrice = undefined;
        this.productPriceName = undefined;
        this.totalPriceTax = 0;
        this.totalPriceWithoutTax = 0;
        this.totalPrice = 0;
    }
}
